import { render, staticRenderFns } from "./ModalProgram.vue?vue&type=template&id=0fa988c7&scoped=true&lang=pug"
import script from "./ModalProgram.vue?vue&type=script&lang=js"
export * from "./ModalProgram.vue?vue&type=script&lang=js"
import style0 from "./ModalProgram.vue?vue&type=style&index=0&id=0fa988c7&prod&lang=scss&scoped=true"
import style1 from "./ModalProgram.vue?vue&type=style&index=1&id=0fa988c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa988c7",
  null
  
)

export default component.exports